import { fmtPct } from "../lib/format";

// Net YTM как «тепловая» ячейка: уровень = 1..5 по абсолютной величине.
// Пороги подобраны под российский корп-рынок (16-25-40-60).
export function Heat({ value }: { value: number }) {
  const pct = value * 100;
  const lvl = pct >= 60 ? 5 : pct >= 40 ? 4 : pct >= 25 ? 3 : pct >= 16 ? 2 : 1;
  return <span className={`heat h${lvl}`}>{fmtPct(value)}</span>;
}
